/**
 * Sprawdza czy elemnt jest odpowiednim komponentem
 *
 * @param {*} component
 * @param {string} className
 * @param {string} tagName
 * @returns {boolean}
 */
export function isComponent(component: any, className: string, tagName: string): boolean {
  let Ctor = component.$vnode.componentOptions.Ctor;
  if (Ctor && Ctor.extendOptions && (Ctor.extendOptions.name === className || Ctor.extendOptions.name === tagName)) {
    return true;
  } else {
    if (component.$vnode.componentOptions.tag === tagName) {
      return true;
    }
  }
  return false;
}

/**
 * Sprawdza czy komponent lub jego dzieci mają błędy
 *
 * @param {*} parentComponent
 * @param {any[]} result
 */
export function traverseError(parentComponent: any, result: any[]) {
  if (parentComponent.model && parentComponent.model.$validate) {
    const validationResult = parentComponent.model.$validate();
    if (validationResult) {
      result.push(parentComponent);
    }
  }

  if (parentComponent.$children) {
    const childrenLength = parentComponent.$children.length;
    for (let i = 0; i < childrenLength; i++) {
      traverseError(parentComponent.$children[i], result);
    }
  }
}
